import * as THREE from 'three';

export function setupThreeDView(headRef, neckRef, leftEyeRef, rightEyeRef) {
  if (!headRef.current || !neckRef.current) {
    return null;
  }

  const updateOrientation = (deviceOrientation) => {
    const { beta, gamma } = deviceOrientation;
    
    // Normalize beta and gamma to smaller ranges for subtler movement
    const normalizedBeta = THREE.MathUtils.clamp(beta / 180, -0.15, 0.15); // Only 15% of full range
    const normalizedGamma = THREE.MathUtils.clamp(gamma / 180, -0.15, 0.15); // Only 15% of full range

    // Very subtle head rotation (max 10 degrees)
    const headRotationX = THREE.MathUtils.degToRad(normalizedBeta * 10);
    const headRotationY = THREE.MathUtils.degToRad(normalizedGamma * 10);

    // Even more subtle neck rotation (max 5 degrees)
    const neckRotationX = headRotationX * 0.5;
    const neckRotationY = headRotationY * 0.5;

    // Apply rotation with smooth lerping
    if (headRef.current) {
      headRef.current.rotation.x = THREE.MathUtils.lerp(
        headRef.current.rotation.x,
        headRotationX,
        0.1  // Slower transition for smoother movement
      );
      headRef.current.rotation.y = THREE.MathUtils.lerp(
        headRef.current.rotation.y,
        headRotationY,
        0.1
      );
    }

    if (neckRef.current) {
      neckRef.current.rotation.x = THREE.MathUtils.lerp(
        neckRef.current.rotation.x,
        neckRotationX,
        0.1
      );
      neckRef.current.rotation.y = THREE.MathUtils.lerp(
        neckRef.current.rotation.y,
        neckRotationY,
        0.1
      );
    }
  };

  const reset = () => {
    if (headRef.current) {
      headRef.current.rotation.set(0, 0, 0);
    }
    if (neckRef.current) {
      neckRef.current.rotation.set(0, 0, 0);
    }
  };

  return {
    updateOrientation,
    reset
  };
} 